const FileClearingMixin = {
  clearUploaded() {
    this.files = (this.files || []).filter((file) => !file.uploaded);
  },
};

export default FileClearingMixin;
